import React from 'react';

import openstackIcon from '@images/spe-cloud/openstack.svg';

export const openstack = {
  mainSection: {
    icon: openstackIcon,
    elements: [
      {
        type: 'text',
        items: [
          <>
            OpenStack is an open-source IaaS (Infrastructure-as-a-Service) cloud computing platform that allows you to
            manage huge pools of virtualized compute, storage, and networking resources across a data centre. It is
            developed under the umbrella of the OpenStack Foundation. More than 500 companies have joined the OpenStack
            project.
          </>,
          <></>,
          <>
            Apart from standard IaaS functionalities, OpenStack has other components providing such services as
            networking (Neutron), compute (Nova) or orchestration (Heat).
          </>,
          <></>,
          <>At CodiLime, we have been working with OpenStack since 2014 (Juno release).</>,
        ],
      },
    ],
  },
  howWeHelpSection: {
    elements: [
      {
        type: 'list',
        items: [
          <>Help with such components as Neutron—networking, Nova—compute and Heat—orchestration</>,
          <>Design software systems running on multiple platform types</>,
          <>Perform requirements analysis and technical design</>,
          <>Prepare a quick PoC for new ideas</>,
          <>
            Develop features, plugins, integrations with software and hardware, comprehensive bug fixing, and
            optimizations
          </>,
          <>Automate testing: features, integrations, performance</>,
          <>Automate deployments with multiple integrations</>,
        ],
      },
    ],
    relatedResources: [
      {
        type: 'Case study',
        items: [
          {
            title: 'Integration of Tungsten Fabric SDN, OVS, and SR-IOV compute nodes by ML2 OpenStack mechanism',
            link: '/case-study/integration-of-tungsten-fabric-sdn-ovs-and-sr-iov-compute-nodes-with-ml2-openstack-mechanism/',
          },
          {
            title: 'Creating an NFV telco cloud based on OpenStack and Tungsten Fabric',
            link: '/case-study/creating-nfv-telco-cloud-based-on-openstack-and-tungsten-fabric/',
          },
        ],
      },

      {
        type: 'Video',
        items: [
          {
            title: 'Integrating Kubernetes CNFs and OpenStack VNFs with Tungsten Fabric',
            link: 'https://www.youtube.com/watch?v=-lZzcq9aZg4',
          },
        ],
      },
    ],
  },
};
